export const FILE_PARENT_TYPES = [
  'chat_messages',
  'menus',
  'recipes',
  'menu_imports'
] as const;

export type FileParentType = (typeof FILE_PARENT_TYPES)[number];

export const IMAGE_CONTENT_TYPES = [
  'image/jpeg',
  'image/png',
  'image/gif',
  'image/webp'
] as const;

export const PDF_CONTENT_TYPE = 'application/pdf' as const;

export const DOCX_CONTENT_TYPE =
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document' as const;

export const ALLOWED_FILE_CONTENT_TYPES = [
  ...IMAGE_CONTENT_TYPES,
  PDF_CONTENT_TYPE,
  DOCX_CONTENT_TYPE
] as const;

export type AllowedFileContentType =
  (typeof ALLOWED_FILE_CONTENT_TYPES)[number];

export const MAX_IMAGE_BYTES = 10 * 1024 * 1024;
export const MAX_PDF_BYTES = 20 * 1024 * 1024;
export const MAX_DOCX_BYTES = 10 * 1024 * 1024;
export const MAX_FILES_PER_PARENT = 10;

export const FILE_ACCEPT: Record<string, string[]> = {
  'image/jpeg': ['.jpg', '.jpeg'],
  'image/png': ['.png'],
  'image/gif': ['.gif'],
  'image/webp': ['.webp'],
  'application/pdf': ['.pdf'],
  [DOCX_CONTENT_TYPE]: ['.docx']
};

export const MENU_IMPORT_ACCEPT: Record<string, string[]> = {
  'image/jpeg': ['.jpg', '.jpeg'],
  'image/png': ['.png'],
  'image/gif': ['.gif'],
  'image/webp': ['.webp'],
  'application/pdf': ['.pdf'],
  [DOCX_CONTENT_TYPE]: ['.docx']
};

export function isImageContentType(contentType: string): boolean {
  return (IMAGE_CONTENT_TYPES as readonly string[]).includes(contentType);
}

export function isPdfContentType(contentType: string): boolean {
  return contentType === PDF_CONTENT_TYPE;
}

export function isDocxContentType(contentType: string): boolean {
  return contentType === DOCX_CONTENT_TYPE;
}

export function isAllowedFileContentType(
  contentType: string
): contentType is AllowedFileContentType {
  return (ALLOWED_FILE_CONTENT_TYPES as readonly string[]).includes(
    contentType
  );
}

export function maxBytesForContentType(contentType: string): number {
  if (isPdfContentType(contentType)) {
    return MAX_PDF_BYTES;
  }
  if (isDocxContentType(contentType)) {
    return MAX_DOCX_BYTES;
  }
  return MAX_IMAGE_BYTES;
}

export function isFileParentType(value: string): value is FileParentType {
  return (FILE_PARENT_TYPES as readonly string[]).includes(value);
}
